var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "fm-app" },
    [
      _c("div", { staticClass: "fm-app__topbar" }),
      _vm._v(" "),
      _c("DebtHelplineBanner"),
      _vm._v(" "),
      _c("header", { staticClass: "fm-app__header" }, [
        _vm.isAuthenticated
          ? _c(
              "a",
              {
                staticClass: "btn-fm btn-fm-back",
                attrs: { href: "/system/dashboard" },
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      fill: "currentColor",
                      viewBox: "0 0 16 16",
                      xmlns: "http://www.w3.org/2000/svg",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z",
                        "fill-rule": "evenodd",
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c("span", [_vm._v("Back to Flashboard")]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "fm-app__header-text" }, [
          _c("h1", { staticClass: "fm-app__title" }, [
            _vm._v(_vm._s(_vm.pageTitle)),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "fm-app__subtitle" }, [
            _vm._v(_vm._s(_vm.pageSubtitle)),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "fm-app__container" },
        [
          _c(
            "Callout",
            {
              staticClass: "callout-unique-info",
              attrs: {
                visible: _vm.uniqueReminderState,
                dismissible: "",
                kind: "primary",
              },
              on: { close: _vm.uniqueReminderClosed },
            },
            [
              _vm._v(
                "\n      This link is unique to your application. Bookmark this page to continue later.\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "fm-card" }, [
            _c(
              "div",
              { staticClass: "fm-card__progress" },
              [
                _c("StepProgress", {
                  attrs: {
                    "current-step": _vm.visibleCurrentIndex,
                    steps: _vm.visibleStepNames,
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { ref: "stepHeader", staticClass: "fm-card__step-title" },
              [
                _c("span", { staticClass: "fm-card__step-number" }, [
                  _vm._v(_vm._s(_vm.visibleCurrentIndex + 1)),
                ]),
                _vm._v(" "),
                _c("h2", { staticClass: "fm-card__step-name" }, [
                  _vm._v(_vm._s(_vm.steps.list[_vm.steps.current])),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "fm-card__step-badge" }, [
                  _vm._v(
                    _vm._s(_vm.visibleCurrentIndex + 1) +
                      " / " +
                      _vm._s(_vm.visibleStepNames.length)
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { ref: "applicationSteps", staticClass: "fm-card__body" },
              [
                _c(
                  "TransitionGroup",
                  {
                    staticClass: "d-block",
                    attrs: { mode: "out-in", name: "fm-fade", tag: "div" },
                  },
                  _vm._l(_vm.stepViews, function (name, idx) {
                    return !_vm.skippedStepIndices.has(idx)
                      ? _c(name, {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: idx === _vm.steps.current,
                              expression: "idx === steps.current",
                            },
                          ],
                          key: name,
                          ref: "steps",
                          refInFor: true,
                          tag: "Component",
                          attrs: { "loan-number": _vm.loanNumber },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "controls",
                                fn: function ({ next, prev }) {
                                  return [
                                    idx === _vm.steps.current
                                      ? _c(
                                          "Portal",
                                          {
                                            attrs: {
                                              to: "new-loan-application-controls",
                                            },
                                          },
                                          [
                                            prev &&
                                            _vm.previousButtonText &&
                                            !_vm.isLocked
                                              ? _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn-fm btn-fm-outline",
                                                    attrs: {
                                                      disabled:
                                                        _vm.disableActionButtons,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.stopPropagation()
                                                        $event.preventDefault()
                                                        return prev.apply(
                                                          null,
                                                          arguments
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "svg",
                                                      {
                                                        attrs: {
                                                          fill: "currentColor",
                                                          viewBox: "0 0 16 16",
                                                          xmlns:
                                                            "http://www.w3.org/2000/svg",
                                                        },
                                                      },
                                                      [
                                                        _c("path", {
                                                          attrs: {
                                                            d: "M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z",
                                                            "fill-rule":
                                                              "evenodd",
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      domProps: {
                                                        textContent: _vm._s(
                                                          _vm.previousButtonText
                                                        ),
                                                      },
                                                    }),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            (next && !_vm.isLastStep) ||
                                            !_vm.isLocked
                                              ? _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn-fm btn-fm-primary",
                                                    attrs: {
                                                      disabled:
                                                        _vm.disableActionButtons,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.stopPropagation()
                                                        $event.preventDefault()
                                                        return next.apply(
                                                          null,
                                                          arguments
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.nextButtonText
                                                        )
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "svg",
                                                      {
                                                        attrs: {
                                                          fill: "currentColor",
                                                          viewBox: "0 0 16 16",
                                                          xmlns:
                                                            "http://www.w3.org/2000/svg",
                                                        },
                                                      },
                                                      [
                                                        _c("path", {
                                                          attrs: {
                                                            d: "M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z",
                                                            "fill-rule":
                                                              "evenodd",
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.isLastStep
                                              ? _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "btn-fm btn-fm-primary",
                                                    attrs: {
                                                      href: _vm.finalCtaHref,
                                                    },
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.finalCtaLabel
                                                        )
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "svg",
                                                      {
                                                        attrs: {
                                                          fill: "currentColor",
                                                          viewBox: "0 0 16 16",
                                                          xmlns:
                                                            "http://www.w3.org/2000/svg",
                                                        },
                                                      },
                                                      [
                                                        _c("path", {
                                                          attrs: {
                                                            d: "M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z",
                                                            "fill-rule":
                                                              "evenodd",
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e()
                  }),
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "fm-bottom-nav",
              class: { "fm-bottom-nav--stuck": _vm.navIsStuck },
            },
            [
              _c("PortalTarget", {
                staticClass: "fm-bottom-nav__inner",
                attrs: {
                  multiple: true,
                  name: "new-loan-application-controls",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { ref: "navSentinel", staticClass: "fm-nav-sentinel" }),
          _vm._v(" "),
          _c("LoadingPlaceholder", {
            attrs: {
              loading: _vm.steps.meta.loading,
              message: _vm.stepLoadingMessage,
              dim: "",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }